'use client';

import React, { useEffect, useRef } from 'react';

const stats = [
  { val: '50-70%', desc: 'of AI SDR customers churn within a year across the category.' },
  { val: '3-5%', desc: 'reply rates from fully automated outreach, against 15 to 25% for signal-based human outreach.' },
  { val: '0', desc: 'AI tools that can handle a live phone objection from a real decision-maker.' },
];

export default function IndustryDataSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    const els = sectionRef?.current?.querySelectorAll('.rev');
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24">
      <div className="max-w-site mx-auto px-7">
        <div className="rev mb-13 max-w-[780px]">
          <div className="eyebrow">The industry data</div>
          <h2 className="heading-2 text-ink">You did not fail. The category did.</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          {stats?.map((s, i) => (
            <div
              key={s?.val}
              className="rev stat-card bg-white border border-line-color rounded-brand p-6"
              style={{ transitionDelay: `${i * 0.08}s` }}
            >
              <b>{s?.val}</b>
              <span>{s?.desc}</span>
            </div>
          ))}
        </div>

        <div className="rev gold-strip mt-8" style={{ transitionDelay: '0.24s' }}>
          <div>
            <b className="text-primary">The model the market settled on is the one we run:</b>{' '}
            software finds the buying signals, a dedicated human picks up the phone. You keep a sensible price point and get back the judgment.
          </div>
        </div>
      </div>
    </section>
  );
}